import { TbBriefcase2 } from "react-icons/tb";
import { TbDeviceImac } from "react-icons/tb";
import { TbLego } from "react-icons/tb";

export const buttons = [
    {id: 1,
    title: 'SERVICES',
    link: '/services',
    icon: <TbBriefcase2 />},
    {id: 2,
    title: 'WORK',
    link: '/work',
    icon: <TbDeviceImac />},
    {id: 3,
    title: 'ABOUT',
    link: '/about',
    icon: <TbLego />},
]

export const contact = {
    title: "LET'S TALK",
    link: '/contact',
}
